export const filterHierarchy = (hierarchy, key, displayRoot = false) => {
    // INFE:SIMPLE RULES START =============================
    // Level 1 'key' always name as 'root' (COMPULSORY)
    // Level 2 to n, key should contain n number of digits separated by '.' (Ex: If you have 5 levels key should something like 1.2.3.1.2 )
    // Order of the levels are VERY IMPORTANT and should spread low to high (Follow the below sample Hierarchy)

    //const fullHierarchy = [
    //    { text: displayText.checkin, key: "root", parent: null }, //Level 1
    //    { text: displayText.checkinNew, key: "1.1", parent: "root" }, //Level 2
    //    { text: displayText.checkinNewRev, key: "1.2", parent: "root" }, //Level 2
    //    { text: displayText.file, key: "1.1.1", parent: "1.1" }, //Level 3
    //    { text: displayText.basic, key: "1.1.2", parent: "1.1" }, //Level 3
    //    { text: displayText.objectConnection, key: "1.1.3", parent: "1.1" }, //Level 3
    //]
    // INFE:SIMPLE RULES END =============================

    let _hierarchy = hierarchy;
    const reArrangedHierarchy = []
    if (key !== null || key !== "") {
        let _findKey = key;
        for (let x = (_hierarchy.length - 1); x >= 0; x--) {
            if (displayRoot === true) {
                if (_hierarchy[x].key === _findKey) {
                    var _matchItem = _hierarchy.find(x => x.key === _findKey);
                    _findKey = _hierarchy[x].parent;
                    reArrangedHierarchy.unshift(_matchItem);
                }
            }
            else {
                if (_hierarchy[x].key === _findKey && _hierarchy[x].key !== "root") {
                    var _matchItem = _hierarchy.find(x => x.key === _findKey);
                    _findKey = _hierarchy[x].parent;
                    reArrangedHierarchy.unshift(_matchItem);
                }
            }
        }
    }
    return reArrangedHierarchy;
}